import React from 'react';
import Typing from 'react-typing-effect';

const TypingSQLCode = () => {
  return (
    <div style={styles.codeContainer}>
      <pre style={styles.pre}>
        <code style={styles.code}>
          <span style={styles.keyword}>CREATE TABLE</span> <span style={styles.table}>QuantumAI</span> {'('}{'\n'}
          &nbsp;&nbsp;<span style={styles.column}>id</span> <span style={styles.type}>INT</span> <span style={styles.constraint}>PRIMARY KEY</span>,{'\n'}
          &nbsp;&nbsp;<span style={styles.column}>state</span> <span style={styles.type}>VARCHAR</span>(<span style={styles.number}>50</span>),{'\n'}
          &nbsp;&nbsp;<span style={styles.column}>goal</span> <span style={styles.type}>VARCHAR</span>(<span style={styles.number}>50</span>){'\n'}
          {')'};{'\n\n'}

          <span style={styles.keyword}>INSERT INTO</span> <span style={styles.table}>QuantumAI</span> {'('}<span style={styles.column}>state</span>, <span style={styles.column}>goal</span>{')'}{'\n'}
          <span style={styles.keyword}>VALUES</span> (<span style={styles.string}>'superposition'</span>, <span style={styles.string}>'solve AGI'</span>);{'\n\n'}

          <span style={styles.keyword}>SELECT</span> * <span style={styles.keyword}>FROM</span> <span style={styles.table}>QuantumAI</span>;{'\n\n'}

          <Typing
            text={[
              "SELECT * FROM QuantumAI WHERE state = 'enhanced';",
              "UPDATE QuantumAI SET state = 'collapsed' WHERE id = 1;",
              "DELETE FROM QuantumAI WHERE goal = 'solved';",
            ]}
            speed={100}
            eraseSpeed={50}
            typingDelay={500}
            eraseDelay={2000}
            displayTextRenderer={(text) => (
              <span style={styles.typingText}>{text}</span>
            )}
          />
        </code>
      </pre>
    </div>
  );
};

// SQL syntax styling
const styles = {
  codeContainer: {
    backgroundColor: '#2b2b2b',
    padding: '16px',
    borderRadius: '8px',
    width: '86%',
    maxWidth: '600px',
    margin: '0 auto',
    fontSize: '18px',
    boxSizing: 'border-box',
  },
  pre: {
    backgroundColor: '#2b2b2b',
    color: '#f8f8f2',
    padding: '8px',
    borderRadius: '8px',
    fontSize: '10px',
    lineHeight: '1.6',
    overflowX: 'auto',
    boxSizing: 'border-box',
  },
  code: {
    fontFamily: '"Fira Code", "Consolas", "Courier New", monospace',
    whiteSpace: 'pre-wrap',
  },
  keyword: { color: '#ff79c6' },
  table: { color: '#8be9fd', fontWeight: 'bold' },
  column: { color: '#50fa7b' },
  type: { color: '#ffb86c' },
  constraint: { color: '#bd93f9', fontStyle: 'italic' },
  string: { color: '#f1fa8c' },
  number: { color: '#bd93f9' },
  typingText: { color: '#f1fa8c' },
};

export default TypingSQLCode;